import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { getMarketInfo, marketUpd } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "marketStatus",
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      loading: false,
      sels: [],
      selsString: '',
      paramsData: {}
    };
  },
  created: function created() {// this.getData()
  },
  methods: {
    handleSource: function handleSource(type) {
      var _this = this;

      if (type == this.tableData[0].type) {
        this.$message.success(this.$t('marketStatusAlready') + (type == '0' ? this.$t('open') : this.$t('close')));
        return;
      }

      marketUpd(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        lock: type
      })).then(function (res) {
        if (res.status == 200) {
          _this.tableData[0].type = type;

          _this.$message.success(_this.$t('operationSuccess'));
        }
      });
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
    },
    getData: function getData(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.tableData = [];

                if (!(_this2.paramsData.server_id.length == 0)) {
                  _context.next = 4;
                  break;
                }

                _this2.$message.error(_this2.$t('pleaseSelectServer'));

                return _context.abrupt("return");

              case 4:
                _this2.loading = true;
                _this2.paramsData.page = e;
                getMarketInfo(_this2.paramsData).then(function (res) {
                  if (res.status == 200) {
                    var data = res.data;

                    var _loop = function _loop(i) {
                      var foundData = _this2.serverListYJ.find(function (item) {
                        return item.serverID == i;
                      });

                      _this2.tableData.push({
                        title: _this2.$t('marketStatus'),
                        type: data[i],
                        serverName: foundData.serverName
                      });
                    };

                    for (var i in data) {
                      _loop(i);
                    }
                  }
                }).finally(function () {
                  _this2.loading = false;
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this3.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm(this.$t('confirmDelete'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                announceChannelDel({
                  id: id,
                  env_id: _this4.paramsData.env_id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.$message.success(_this4.$t('deleteSuccess'));

                    _this4.getData(_this4.paramsData.page);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};